import axios from '../../config/axios.js'
import store from '../../vuex/store.js'
import { addIso690 } from '../../custom/function.js'


const STATE = {

    check_result: [],
    compare_mode: { mode: null, complete: false },

    docs_compare: [],
    src_compare_new: [],
    src_compare_exist: [],
    src_compare_update: [],
    docs_result: [],

    input_doc_key: null,
    input_result: null,
    input_docs_new: [],
    input_refs_new: [],
    keys_total: [],

    files: [],
    format: null,
    text: '',
    download_url: null,

    temp_ref_keys: [],
    add_ref_keys: [],
    document: {},
    new_document: {},

    manual_doc_type: null,

    import_error_type: null,

    suggestions: [],

    referred_docs: [],
}

const GETTERS = {

    check_result: state => state.check_result,
    compare_mode: state => state.compare_mode,
    input_doc_key: state => state.input_doc_key,
    input_result: state => state.input_result,
    input_docs_new: state => state.input_docs_new,
    input_refs_new: state => state.input_refs_new,
    keys_total: state => state.keys_total,

    docs_compare: state => state.docs_compare,
    src_compare_new: state => state.src_compare_new,
    src_compare_exist: state => state.src_compare_exist,
    src_compare_update: state => state.src_compare_update,

    docs_result: state => state.docs_result,

    files: state => state.files,
    format: state => state.format,
    text: state => state.text,
    download_url: state => state.download_url,

    temp_ref_keys: state => state.temp_ref_keys,
    add_ref_keys: state => state.add_ref_keys,
    document: state => state.document,
    new_document: state => state.new_document,

    manual_doc_type: state => state.manual_doc_type,

    import_error_type: state => state.import_error_type,
    import_error_code: state => state.import_error_code,

    suggestions: state => state.suggestions,

    referred_docs: state => state.referred_docs,
}

const MUTATIONS = {

    initialize(state) {
        state.check_result = []
        state.compare_mode = { mode: null, complete: false }

        state.input_doc_key = null
        state.input_result = null
        state.input_docs_new = []
        state.input_refs_new = []

        state.docs_compare = []
        state.src_compare_new = []
        state.src_compare_exist = []
        state.src_compare_update = []

        state.docs_result = []
    },

    checkDocuments(state, check_result) {
        state.check_result = check_result
    },

    setCompareMode(state, mode) {
        state.compare_mode = mode
    },

    setCompareModeComplete(state, complete) {
        state.compare_mode.complete = complete
    },

    updateDocsCompare(state, docs_compare) {
        state.docs_compare = docs_compare
    },

    updateSrcCompare(state, payload) {
        state.src_compare_new = payload.new
        state.src_compare_exist = payload.exist
        state.src_compare_update = payload.update
    },

    updateDocsResult(state, docs_result) {
        state.docs_result = docs_result
    },

    setInputDocKey(state, input_doc_key) {
        state.input_doc_key = input_doc_key
    },

    setInputResult(state, input_result) {
        state.input_result = input_result
    },

    inputDocuments(state, input_docs_new) {
        state.input_docs_new = input_docs_new
    },

    inputReferences(state, input_refs_new) {
        state.input_refs_new = input_refs_new
    },

    uploadFiles(state, files) {
        state.files = files
    },

    setInputFormat(state, format) {
        state.format = format
    },

    setInputText(state, text) {
        state.text = text
    },

    getDownloadURL(state, url) {
        state.download_url = url
    },

    setTempRefKeys(state, keys) {
        state.temp_ref_keys = keys
    },

    setAddRefKeys(state, keys) {
        state.add_ref_keys = keys
    },

    getDocument(state, document) {
        state.document = document
    },

    getNewDocument(state, document) {
        state.new_document = document
    },

    setManualDocType(state, doc_type) {
        state.manual_doc_type = doc_type
    },

    throwErrorImportFiles(state, error_type) {
        state.import_error_type = error_type
    },

    throwErrorCodeImportFiles(state, error_code) {
        state.import_error_code = error_code
    },

    updateKeysTotal(state, keys) {
        state.keys_total = keys
    },

    getSuggestions(state, documents) {
        state.suggestions = documents
    },

    getReferredDocs(state, document) {
        state.referred_docs = document
    },

}

const ACTIONS = {

    async checkDocuments({ commit }, docs_array) {
        // console.log('payload', docs_array)
        await axios.ACCESS.post('/api/bt/batch/check', docs_array)
            .then(async(res) => {
                // console.log('input/checkDocuments', res)
                if (res.data.result) {
                    commit('checkDocuments', res.data.check_result)
                } else { throw new Error(res.data) }
            })
    },

    async inputDocuments({ commit }, documents) {
        await axios.ACCESS.post('/api/bt/batch/document', documents)
            .then(async(res) => {
                // console.log('input/inputDocuments', res)
                if (res.data.result) {
                    commit('inputDocuments', res.data.docs_new)
                } else { throw new Error(res.data) }
            })
    },

    async addReferences({ dispatch }, payload) {
        await axios.ACCESS.post('/api/document/' + payload.doc_key + '/references', {
                documents: payload.documents
            })
            .then(res => {
                // console.log('input/addReferences', res)
                if (res.data.result) {
                    store.dispatch('document/getDocument', payload.doc_key)
                    store.dispatch('project/getProject', {
                        proj_id: payload.proj_id
                    })
                    store.commit('tree/changeTree', true)
                } else { throw new Error(res.data) }
            })
    },

    // check within which component
    async inputReferences({ commit }, references) {
        await axios.ACCESS.post('/api/bt/batch/reference', references)
            .then(res => {
                // console.log('input/inputReferences', res)
                commit('inputReferences', res.data.docs_new)
                store.dispatch('document/getDocument', references.doc_origin)
            })
    },

    async downloadFile({ commit }, payload) {
        await axios.ACCESS.get('/api/files/' + payload.filename, {
                responseType: 'blob'
            })
            .then(res => {
                // console.log('input/downloadFile', res)
                let url = window.URL.createObjectURL(new Blob([res.data]))
                commit('getDownloadURL', url)
            })
    },

    async removeReferences({ commit }, payload) {
        await axios.ACCESS.put('/api/bt/document/' + payload.doc_origin + '/references', {
                documents: payload.documents
            })
            .then(res => {
                // console.log('input/removeReferences', res)
                store.dispatch('document/getDocument', payload.doc_origin)
                store.dispatch('project/getProject', {
                    proj_id: payload.proj_id
                })
                store.commit('tree/changeTree', true)
            })
    },

    async getDocument({ commit, dispatch }, doc_key) {
        await axios.ACCESS.get('/api/bt/document/' + doc_key)
            .then(res => {
                // console.log('input/getDocument', res)
                addIso690([res.data.document])
                    .then(res => {
                        commit('getDocument', res[0])
                    })
            })
        await axios.ACCESS.get('/api/bt/document/' + doc_key + '/references')
            .then(res => {
                // console.log('input/getReferences', res)
                addIso690(res.data.referred_docs)
                    .then(res => {
                        // console.log(res)
                        commit('getReferredDocs', res)
                    })
            })
    },

    async getNewDocument({ commit, dispatch }, doc_key) {
        await axios.ACCESS.get('/api/bt/document/' + doc_key)
            .then(res => {
                // console.log('input/getNewDocument', res)
                if (res.data.result) {
                    addIso690([res.data.document])
                        .then(res => {
                            commit('getNewDocument', res[0])
                        })
                } else { throw new Error(res.data) }
            })
    },

    async getSuggestions({ commit }, query) {
        await axios.ACCESS.post('/api/bt/document/suggest', query)
            .then(res => {
                // console.log('input/getSuggestions', res)
                if (res.data.result) {
                    addIso690(res.data.documents)
                        .then(res => {
                            commit('getSuggestions', res)
                        })
                } else { throw new Error(res.data) }
            })
    },

}

export default {
    namespaced: true,
    state: STATE,
    getters: GETTERS,
    mutations: MUTATIONS,
    actions: ACTIONS,
}


// WEBPACK FOOTER //
// ./src/vuex/modules/input.js